import { KeyOutlined, LinkOutlined, ToolOutlined, UserSwitchOutlined } from "@ant-design/icons";
import TabSelection from "../../components/SelectContent/TabSelection";
import { setSuperAdminTab } from "../../state/slices/generalSlice";
import AdminRoles from "./AdminRoles";
import ExternalAppsPage from "./ExternalAppsPage";
import QuickLinksPage from "./QuickLinksPage";
import MaintenanceSettings from "./MaintenanceSettings";

const menuItems = [
  {
    key: "admin-roles",
    label: "Admin Roles",
    icon: <UserSwitchOutlined />,
    component: <AdminRoles />,
  },
  {
    key: "external-apps",
    label: "External Apps",
    icon: <KeyOutlined />,
    component: <ExternalAppsPage />,
  },
  {
    key: "quick-links",
    label: "Quick Links",
    icon: <LinkOutlined />,
    component: <QuickLinksPage />,
  },
  {
    key: "maintenance",
    label: "Maintenance",
    icon: <ToolOutlined />,
    component: <MaintenanceSettings />,
  },
];

const SuperAdminPage = () => {
  return (
    <TabSelection
      menuItems={menuItems}
      currentTabKey="superAdminCurrentTab"
      setTabAction={setSuperAdminTab}
    />
  );
};

export default SuperAdminPage;
